import { useLocation } from "@reach/router";
import { Link } from "gatsby";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import close from "../assets/closeSidebar.svg";
import facebook from "../assets/facebook.svg";
import instagram from "../assets/instagram.svg";
import youtube from "../assets/youtube.svg";

import { isMobile } from "react-device-detect";
import arrow from "../assets/gray-arrow.svg";

const Container = styled.nav`
  display: flex;
  height: 85vh;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  background-color: #f1f1f1;
  z-index: 1010;
  top: ${isMobile ? "73px" : "69px"};
  padding-left: 40px;
  padding-top: 1vh;
  width: 15%;
  right: ${(props) => (props.isOpen ? "0" : "-100%")};
  position: fixed;
  transition: all 0.5s;
  -webkit-transition: all 0.15s;
  .child-container {
    display: none;
    overflow: hidden;
    padding-left: 10px;
  }

  a {
    text-decoration: none;
  }
  .header-arrow {
    width: 12px;
    margin-left: 5px;
  }
  .footer-media-container {
    display: flex;
    flex-direction: row;
    gap: 15px;
    margin-bottom: 20px;
  }
  .footer-media > img {
    filter: brightness() invert(1);
  }
  .twitter:hover {
    background: #1da1f2;
    transition: 0.3 ease-in-out;
    > img {
      filter: brightness(0) invert(1);
    }
  }
  .facebook:hover {
    background: #3b5998;
    transition: 0.3 ease-in-out;
    > img {
      filter: brightness(0) invert(1);
    }
  }
  .youtube:hover {
    background: #ff0000;
    transition: 0.3 ease-in-out;
    > img {
      filter: brightness(0) invert(1);
    }
  }
  .instagram:hover {
    background: #dc2743;
    transition: 0.3 ease-in-out;
    > img {
      filter: brightness(0) invert(1);
    }
  }
  @media (max-width: 1200px) {
    width: 92%;
    padding-left: 8%;
    overflow-y: scroll;
  }
`;

const Close = styled.img`
  position: absolute;
  width: 15px;
  height: 15px;
  right: 20px;
  top: 20px;
  cursor: pointer;
  @media (max-width: 1200px) {
    width: 20px;
    height: 20px;
  }
`;

const SidebarLink = styled.a`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 89.5%;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.065em;
  color: rgb(90,90,90) !important;

  margin-bottom: 20px;
  margin-top: 20px;
  text-decoration: none;
  :hover {
    color: #006bd6;
  }

  & .newColor {
    color: rgb(90,90,90);
  }
`;

const SidebarLinkSmall = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 110.5%;
  display: flex;
  align-items: center;
  text-align: left;
  letter-spacing: 0.065em;
  color: rgb(90,90,90);

  margin-bottom: 15px;
  text-decoration: none;
  &:last-child {
    margin-bottom: 0px;
  }
  a:hover {
    color: #006bd6;
  }

  & .newColor {
    color: rgb(90,90,90);
  }
`;

const SidebarText = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 89.5%;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.065em;
  color: rgb(90,90,90);

  margin-top: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  text-decoration: none;
  &.border {
    padding-top: 20px;
    border-top: 1px solid #5a5a5a;
    width: fit-content;
  }
  :hover {
    color: #006bd6;
  }
`;

const SidebarTextLink = styled.a`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 89.5%;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.065em;
  color: rgb(90,90,90);

  margin-top: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  text-decoration: none;

  &.border {
    padding-top: 20px;
    border-top: 1px solid #5a5a5a;
    width: fit-content;
  }
  :hover {
    color: #006bd6;
  }
`;

const SidebarTextLine = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 89.5%;
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.065em;
  color: rgb(90,90,90);

  margin-top: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  text-decoration: none;
  &.border {
    padding-top: 2px;
    border-top: 1px solid #5a5a5a;
    width: 190px;
  }
`;

const SideBarPayBill = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  display: flex;
  align-items: center;
  border-radius: 5px;

  text-align: center;
  justify-content: center;
  letter-spacing: 0.065em;
  color: white;
  margin-top: 15px;
  margin-bottom: 15px;
  cursor: pointer;
  text-decoration: none;
  width: 75%;
  background-color: #5a5a5a;
  padding: 10px;

  :hover {
    background-color: #006bd6 !important;
    transition: all 0.3s ease 0s, transform 0.5s ease 0s;
  }

  &.border {
    padding-bottom: 2px;
    border-bottom: 1px solid #5a5a5a;
    width: 190px;
    margin-bottom: 10px;
  }
`;

const SideBarMobibleBookNow = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  letter-spacing: 0.065em;
  color: white;
  margin-top: 30px;
  margin-bottom: 20px;
  cursor: pointer;
  text-decoration: none;
  width: 75%;
  border-radius: 5px;
  background-color: #006bd6;
  padding: 10px;

  :hover {
    background-color: #5983ff !important;
    transition: all 0.3s ease 0s, transform 0.5s ease 0s;
  }

  &.border {
    padding-bottom: 2px;
    border-bottom: 1px solid #5a5a5a;
    width: 190px;
    margin-bottom: 10px;
  }
`;

const Sidebar = ({ set0penSidebar, isOpen }) => {
  const [openAbout, setOpenAbout] = useState(false);
  const [openLocations, setOpenLocations] = useState(false);
  const [openPatients, setOpenPatients] = useState(false);
  const [openSpecialties, setOpenSpecialties] = useState(false);
  const [openHelp, setOpenHelp] = useState(false);

  // const { toggleSidebar, openSidebarContext } = useSidebar();
  const location = useLocation(); // Get the current location using React Router

  const toggleScroll = (position) => {
    const body = document.getElementsByTagName("body");
    body[0].style.overflow = position;
  };

  const closeSidebar = () => {
    toggleScroll("auto");
    // toggleSidebar();
    set0penSidebar(false);
  };

  useEffect(() => {
    if (isOpen) {
      toggleScroll("hidden");
    } else {
      toggleScroll("auto");
    }
  }, [isOpen]);

  const handleLinkClick = (url) => {
    if (location.pathname.includes(url)) {
      // If the user is already on the clicked page, close the sidebar
      // closeSidebar();
      set0penSidebar(false);
    }
    // You can add other logic here for handling external links, etc.
  };

  // console.log("location", location.pathname);

  return (
    <Container isOpen={isOpen} className="sidebar">
      <Close src={close} onClick={() => closeSidebar()} />
      <div style={{ overflowY: "scroll", paddingBottom: "150px" }}>
        <>
          <Link to="/appointment">
            <SideBarMobibleBookNow>Book Now</SideBarMobibleBookNow>
          </Link>

          <div
            style={{
              width: "80%",
              height: "1px",
              backgroundColor: "#5A5A5A",
            }}
          ></div>
        </>

        <a
          href="https://nyga.mygportal.com/PP6-0-0/Account/LogOn"
          target="_blank"
          style={{ textDecoration: "none", color: "white" }}
          rel="noreferrer"
        >
          <SideBarPayBill>Patient Portal</SideBarPayBill>
        </a>

        <Link to="/pay-bill">
          <SideBarPayBill>Pay Bill</SideBarPayBill>
        </Link>

        <div
          style={{
            width: isMobile ? "80%" : "190px",
            height: "1px",
            backgroundColor: "#5A5A5A",
          }}
        ></div>

        <SidebarText onClick={() => setOpenHelp(!openHelp)}>
          How can we help you?
          <img
            src={arrow}
            alt="arrow"
            style={{
              transform: openHelp ? "rotate(90deg)" : "rotate(90deg)",
              transition: "all 0.5s",
              WebkitTransition: "all 0.5s",
              width: "12px",
              height: "12px",
              marginLeft: "5px",
            }}
          />
        </SidebarText>
        <div
          className="child-container help-sidebar"
          style={{ display: openHelp ? "block" : "none" }}
        >
          <SidebarLinkSmall>
            <Link to="/specialties/not-feeling-well" className="newColor">
              Not Feeling Well
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/specialties/screening-colonoscopy" className="newColor">
              Screening Colonoscopy
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link
              to="/specialties/crohns-colitis-management"
              className="newColor"
            >
              Crohn’s & Colitis Management
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link
              to="/specialties/womens-digestive-health"
              className="newColor"
            >
              Women’s Digestive Health
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/specialties/hemorrhoids" className="newColor">
              Hemorrhoids
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/specialties/liver-health" className="newColor">
              Liver Health
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/specialties/nutrition-counseling" className="newColor">
              Nutrition Counseling
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/services" className="newColor">
              All Services
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/conditions" className="newColor">
              All Conditions
            </Link>
          </SidebarLinkSmall>
        </div>

        <SidebarLink>
          <Link to="/providers" className="newColor">
            Providers
          </Link>
        </SidebarLink>

        <SidebarText onClick={() => setOpenLocations(!openLocations)}>
          Locations
          <img
            src={arrow}
            // className="header-arrow"
            alt="arrow"
            style={{
              transform: openLocations ? "rotate(90deg)" : "rotate(90deg)",
              transition: "all 0.5s",
              WebkitTransition: "all 0.5s",
              width: "12px",
              height: "12px",
              marginLeft: "5px",
            }}
          />
        </SidebarText>
        <div
          className="child-container location-sidebar"
          style={{ display: openLocations ? "block" : "none" }}
        >
          <SidebarLinkSmall>
            <Link to="/locations" className="newColor">
              Offices
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/surgery-centers" className="newColor">
              Surgery Centers
            </Link>
          </SidebarLinkSmall>
        </div>

        <SidebarText onClick={() => setOpenSpecialties(!openSpecialties)}>
          Specialties
          <img
            src={arrow}
            // className="header-arrow"
            alt="arrow"
            style={{
              transform: openSpecialties ? "rotate(90deg)" : "rotate(90deg)",
              transition: "all 0.5s",
              WebkitTransition: "all 0.5s",
              width: "12px",
              height: "12px",
              marginLeft: "5px",
            }}
          />
        </SidebarText>
        <div
          className="child-container speciaties-sidebar"
          style={{ display: openSpecialties ? "block" : "none" }}
        >
          <SidebarLinkSmall>
            <Link to="/services" className="newColor">
              Services
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/conditions" className="newColor">
              Conditions
            </Link>
          </SidebarLinkSmall>
        </div>

        <SidebarLink>
          <Link to="/clinical-research" className="newColor">
            Clinical Research
          </Link>
        </SidebarLink>

        <SidebarText onClick={() => setOpenPatients(!openPatients)}>
          Patient Resources
          <img
            src={arrow}
            // className="header-arrow"
            alt="arrow"
            style={{
              transform: openPatients ? "rotate(90deg)" : "rotate(90deg)",
              transition: "all 0.5s",
              WebkitTransition: "all 0.5s",
              width: "12px",
              height: "12px",
              marginLeft: "5px",
            }}
          />
        </SidebarText>

        <div
          className="child-container patient-sidebar"
          style={{ display: openPatients ? "block" : "none" }}
        >
          <SidebarLinkSmall>
            <Link to="/frequently-asked-questions"  className="newColor">
              Frequently Asked Questions
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/patient-forms" className="newColor">
              Patient Forms
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/prepare-for-procedure" className="newColor">
              Procedure and Test Prep
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/accepted-insurances" className="newColor">
              Accepted Insurances
            </Link>
          </SidebarLinkSmall>
        </div>

        <SidebarText onClick={() => setOpenAbout(!openAbout)}>
          About Us
          <img
            src={arrow}
            // className="header-arrow"
            alt="arrow"
            style={{
              transform: openAbout ? "rotate(90deg)" : "rotate(90deg)",
              transition: "all 0.5s",
              WebkitTransition: "all 0.5s",
              width: "12px",
              height: "12px",
              marginLeft: "5px",
            }}
          />
        </SidebarText>
        <div
          className="child-container about-sidebar"
          style={{ display: openAbout ? "block" : "none" }}
        >
          <SidebarLinkSmall>
            <Link to="/why-nyga" className="newColor">
              Why NYGA
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/patient-reviews" className="newColor">
              Patient Reviews
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/webinars" className="newColor">
              Webinars
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/blog" className="newColor">
              Blogs
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/news" className="newColor">
              News
            </Link>
          </SidebarLinkSmall>
          <SidebarLinkSmall>
            <Link to="/administration" className="newColor">
              Administration
            </Link>
          </SidebarLinkSmall>
        </div>

        {isMobile ? (
          <>
            <SidebarTextLink className="border">
              <a
                href="tel:'212-996-6633'"
                style={{
                  textDecoration: "none",
                  color: "rgb(90,90,90)",
                  fontSize: "16px",
                }}
              >
                Call: 212-996-6633
              </a>
            </SidebarTextLink>
            <SidebarTextLink>
              <a
                href="sms:6464194947"
                style={{
                  textDecoration: "none",
                  // color: "#757575",
                  color: "rgb(90,90,90)",

                  fontSize: "16px",
                }}
              >
                Text: 646-419-4947
              </a>
            </SidebarTextLink>
          </>
        ) : (
          <SidebarTextLine className="border"></SidebarTextLine>
        )}

        <div className="footer-media-container">
          <a
            href="https://www.instagram.com/newyorkgastro/"
            className="footer-media instagram"
            target="_blank"
            rel="noreferrer"
          >
            <img src={instagram} alt="instagram" />
          </a>
          <a
            href="https://www.facebook.com/newyorkgastro"
            className="footer-media facebook"
            target="_blank"
            rel="noreferrer"
          >
            <img src={facebook} alt="facebook" />
          </a>
          <a
            href="https://www.youtube.com/channel/UCZwS_2rzXxHdIm_xkQb2b9A"
            className="footer-media youtube"
            target="_blank"
            rel="noreferrer"
          >
            <img src={youtube} alt="youtube" />
          </a>
        </div>
      </div>
    </Container>
  );
};

export default Sidebar;
